/**
 * Typed access to the user_cvs table.
 * The table exists in the DB but is not in generated Supabase Database types.
 * Single cast is confined here so call sites do not use 'any'.
 */
import { supabase } from "@/integrations/supabase/client";

export function getUserCvsTable() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- user_cvs not in generated types; single escape hatch
  return (supabase as any).from("user_cvs");
}
